export const equalJson = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b)
